var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Breadcrumb',{attrs:{"breadcrumb":_vm.breadcrumb}}),_vm._v(" "),_c('div',{staticClass:"register"},[_c('b-container',[_c('div',{staticClass:"pt-5 pb-5"},[_c('FormRegister')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }